<template></template>

<script>
export default {
  name: 'CompanyCardHintError',
}
</script>
